export const darkModeKey = "darkMode";

export const styleKey = "style";

export const containerMaxW = "xl:max-w-9xl xl:mx-auto";

export const calendlySupportUrl =
  import.meta.env.VITE_CALENDLY_SUPPORT_URL || "https://calendly.com/stationops/30min";

export const calendlySupportEmbedUrl = (() => {
  try {
    const url = new URL(calendlySupportUrl);
    url.searchParams.set("hide_gdpr_banner", "1");
    return url.toString();
  } catch {
    return calendlySupportUrl;
  }
})();

// export const containerMaxW = "xl:max-w-7xl xl:mx-auto";
